import { MastheadPortalId } from '../../../models/AdminModels';
import { NavigationBreadcrumbsBar } from '../../../web/components/NavigationBreadcrumbsBar';
import { NotFound } from '../../../web/components/NotFound';
import { Portal } from '../../../web/components/Portal';
import { styleSheet } from './styles';
import { css } from 'aphrodite';
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';

interface IProps extends RouteComponentProps<any> {
	className?: string;
}

const AdminNotFoundContainerBase: React.FC<IProps> = props => {
	const { className = '' } = props;
	return (
		<div className={`${css(styleSheet.notFoundContainer)} ${className}`}>
			<Portal destination={MastheadPortalId}>
				<NavigationBreadcrumbsBar currentLocationName='404' />
			</Portal>
			<NotFound />
		</div>
	);
};

export const AdminNotFoundContainer = withRouter(AdminNotFoundContainerBase);
